<template>
  <div class="custom-phone-input">
    <label v-if="isLabel" :for="id" class="control-box__label">{{ $t('auth_phone_label') }}*</label>
    <TheMask
      name="phone"
      :id="id"
      :value="value"
      @input="$emit('input', $event)"
      type="tel"
      :masked="false"
      :disabled="disableFields"
      :mask="mask"
      :placeholder="placeholder"
      class="control control--phone-auth control--input control-box__control"
      :class="{'control--error': isError}"
      ref="phone"
      :autocomplete="autocomplete"
      @blur.native="$emit('blur')"
      @focus.native="$emit('onFocus')"
    ></TheMask>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'

export default {
  name: 'PhoneInput',
  components: { TheMask },
  props: {
    disableFields: Boolean,
    value: String,
    id: String,
    isLabel: Boolean,
    placeholder: {
      type: String,
      default: '+__ (___) ___ ___'
    },
    autocomplete: {
      type: String,
      default: 'tel'
    },
    isError: {
      type: Boolean,
      default: false
    },
    mask: {
      type: String,
      default: '+## (###) ### ###'
    }
  }
}
</script>

<style scoped></style>
